module.exports = __webpack_public_path__ + "img/256.3ee25a47.jpg";